module.exports = __webpack_public_path__ + "static/img/15.1b4bee3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/eng/15.png
// module id = IPTn
// module chunks = 0